//Resets the button - fixes a safari bug when the user clicks the back button
const resetTopSubmitButton = () => {
  if (FS.Browser.getMake() === "safari") {
    const submitButtonEl = document.getElementById('surnameSubmitFormBtn');
    if (submitButtonEl && submitButtonEl.classList.contains('fs-button--loading')) {
      submitButtonEl.classList.remove('fs-button--loading');
    }
  }
}
const isOnIOS = navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i);
const eventName = isOnIOS ? "pagehide" : "beforeunload";
window.addEventListener(eventName, resetTopSubmitButton);
const handleFormSubmitButton = event => {
  const formEl = document.getElementById('surnameDiscoveryForm');
  if (!formEl.checkValidity()) return;
  const submitButtonEl = document.getElementById('surnameSubmitFormBtn');
  if (submitButtonEl.classList.contains('fs-button--loading')) {
    event.preventDefault();
  } else {
    submitButtonEl.classList.add('fs-button--loading');
  }
}
document.getElementById('surnameSubmitFormBtn').addEventListener('click', handleFormSubmitButton);